import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';
import Head from 'next/head';

import { Image } from 'components';
import { Page } from 'components/layouts';
import { MatchesProgress } from 'components/candidate/matches';
import { getLayout } from 'components/layouts/Header';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';
import { useCandidateMatches } from 'lib/providers/CandidateMatchesProvider';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from '../NoMatches.module.scss';

const CandidateMatchesGenerating = () => {
  const [t] = useTranslation('candidate.matches.generating');
  const { isMatchesRegenerating } = useCandidateMatches();
  const { replace } = useRouter();

  useEffect(() => {
    if (!isMatchesRegenerating) {
      replace(PAGE_ROUTES.CANDIDATE_MATCHES);
    }
  }, [isMatchesRegenerating]);

  return (
    <>
      <Head>
        <title>Matches | Huzzle</title>
      </Head>
      <Page className={styles.page}>
        <MatchesProgress className={styles['matches-progress']} />
        <section className={styles.container}>
          <div className={cx(styles.content, styles['generating-content'])}>
            <div className={cx(styles['main'], styles['no-image'])}>
              <p className={styles.emoji}>{t('emoji')}</p>
              <p className={styles.title}>{t('title')}</p>
              <p className={styles.description}>{t('description')}</p>
              <p className={styles['description-divider']}></p>
              <p className={cx(styles.description, styles['description-down'])}>
                {t('scanning-text')}
              </p>
            </div>
            <footer className={styles['loading-footer']}>
              <Image
                src="/images/loading.gif"
                alt="loader"
                width={120}
                height={120}
              />
              <p className={styles['scanning-text']}>
                {t('search-progress-text')}
              </p>
            </footer>
          </div>
        </section>
      </Page>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.CANDIDATE_MATCHES_GENERATING],
      })),
    },
  };
}

const CandidateMatchesGeneratingWrapper = withAuthCandidate(
  CandidateMatchesGenerating
);

// @ts-ignore
CandidateMatchesGeneratingWrapper.getLayout = getLayout;

export default CandidateMatchesGeneratingWrapper;
